const FolderIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 6H11L9 4H4C2.9 4 2 4.9 2 6V10H22V8C22 6.9 21.1 6 20 6Z" fill="currentColor" />
      <path
        d="M20 6H11L9 4H4C2.9 4 2 4.9 2 6V10H22V8C22 6.9 21.1 6 20 6Z"
        fill="#000"
        fillOpacity="0.2"
      />
      <path
        d="M20 6H4C2.9 6 2 6.9 2 8V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default FolderIcon;
